import React from "react";
import { useSelector } from "react-redux";
import { Field } from "formik";
import { Box } from "@mui/material";

import { ICustomerPlan } from "../../../../../../api/accounts/index.types";
import { IntlFormatUSD } from "../../../../../../utils";

import { CurrentPlanPrice, DefaultExpirationService } from "../PlansTable/utils";
import { FormInput } from "../../../../../../components/ui";
import { Money } from "../../../../../../utils/Money";

interface IProps {
  index: number;
  plan: ICustomerPlan;
  isEditing: boolean;
}

interface IEditCurrentPlanPriceProps {
  index: number;
}
const EditCurrentPlanPrice: React.FC<IEditCurrentPlanPriceProps> = ({ index }) => (
  <Box maxWidth="80px">
    <Field
      type="number"
      variant="standard"
      name={`plans.${index}.price_usd`}
      component={FormInput}
    />
  </Box>
);

const PlansPriceData: React.FC<IProps> = ({ plan, index, isEditing }) => {
  const {
    data: { billing_history_by_plans },
  } = useSelector((state) => state.customer.plans);
  const billing_history = billing_history_by_plans[index] || {
    price_usd: plan.price_usd,
  };

  const { discount_code } = plan;
  // const one_time = discount_code?.one_time;

  const { isOutExpiration, isNoOutExpiration, isHasExpiration } =
    new DefaultExpirationService().getExpirationData(plan);

  const isAvailableForEditing =
    isEditing && (!discount_code || !isHasExpiration || !isNoOutExpiration || isOutExpiration);

  const isChangedPriceAfterExpiration =
    isHasExpiration && plan.price_usd !== billing_history.price_usd;

  const planPrice = new CurrentPlanPrice(plan, billing_history);
  return (
    <>
      {/*Initial Plan Price column*/}
      <Box component="td" sx={{ ...(isOutExpiration && { textDecoration: "line-through" }) }}>
        {discount_code /*&& one_time*/ || isChangedPriceAfterExpiration
          ? IntlFormatUSD(Money.fromCents(billing_history.price_usd))
          : IntlFormatUSD(Money.fromCents(plan.price_usd))}
      </Box>
      {/*Current Plan Price column*/}
      <td>
        {isAvailableForEditing ? (
          <EditCurrentPlanPrice index={index} />
        ) : (
          IntlFormatUSD(planPrice.calculate())
        )}
      </td>
    </>
  );
};

export default PlansPriceData;
